"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTitle = exports.StyledDesc = exports.StyledBanner = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../lib/utils");

var _templateObject, _templateObject2, _templateObject3;

var typeBackgroundColorMap = {
  info: (0, _utils.getPalette)('blue', '100')(),
  warning: (0, _utils.getPalette)('orange', '100')(),
  error: (0, _utils.getPalette)('red', '100')(),
  success: (0, _utils.getPalette)('green', '100')()
};

var StyledBanner = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  padding: 12px;\n  box-sizing: border-box;\n  background-color: ", ";\n  display: flex;\n  align-items: flex-start;\n  border-radius: 4px;\n  transition: box-shadow 0.2s ease-in-out;\n  border: 1px solid ", ";\n  ", "\n"])), function (props) {
  return typeBackgroundColorMap[props.type];
}, function (props) {
  return props.color;
}, function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right; flex-direction: row-reverse;";
});

exports.StyledBanner = StyledBanner;

var StyledTitle = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  ", ";\n  color: ", ";\n  padding-left: 16px;\n  margin-bottom: 8px;\n"])), function (props) {
  return (0, _utils.getTypography)('body5')(props);
}, function (props) {
  return (0, _utils.getPalette)('dark', '400')(props);
});

exports.StyledTitle = StyledTitle;

var StyledDesc = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  color: ", ";\n  padding-left: 16px;\n"])), function (props) {
  return (0, _utils.getTypography)('body4')(props);
}, function (props) {
  return (0, _utils.getPalette)('dark', '400')(props);
});

exports.StyledDesc = StyledDesc;